function getParams(query) {
    if (!query) {
        return {};
    }
    return (/^[?#]/.test(query) ? query.slice(1) : query)
        .split('&')
        .reduce((params, param) => {
            let [key, value] = param.split('=');
            params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
            return params;
        }, {});
}

export function cacheSet(name, data, exp) {
    name = getParams(window.location.search).webId + '_' + name;
    return window.lscache.set(name, data, exp / 60);
}

export function cacheGet(name) {
    name = getParams(window.location.search).webId + '_' + name;
    return window.lscache.get(name);
}



// WEBPACK FOOTER //
// ./src/helpers/Cache.js